module.exports = "<app-employee-navtab></app-employee-navtab>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/employee-routes/employee-routes.component.html
// module id = ./src/app/components/employee-routes/employee-routes.component.html
// module chunks = main